<div *ngIf="isTableReadOnly || !!paymentRules">
  <p-table
    #documentTable
    aurCompactTable
    id="document-table"
    dataKey="urn"
    sortField="documentDate"
    paginatorDropdownAppendTo="body"
    selectionMode="multiple"
    [columns]="columns"
    [value]="modifiedSessionDocuments"
    [paginator]="true"
    [rows]="10"
    [scrollable]="true"
    [scrollHeight]="scrollHeight"
    [rowsPerPageOptions]="[10, 25, 50]"
    [totalRecords]="modifiedSessionDocuments.length"
    [sortOrder]="-1"
    [customSort]="true"
    [selection]="selectedDocuments"
    (sortFunction)="sortTable($event)"
    (onSort)="onTableSort()"
    (selectionChange)="onSelectionChanged($event)"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th
          *ngIf="!isReadOnly"
          pFrozenColumn
          [frozen]="freezeColumns"
          [ngClass]="{ unfrozen: !freezeColumns }"
          style="width: 36px"
        >
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th
          *ngFor="let col of columns"
          pFrozenColumn
          class="{{ col.field }}"
          [frozen]="col.frozen"
          [alignFrozen]="col.alignFrozen"
          [pSortableColumn]="col.sortable ? col.field : null"
          [hidden]="!col.visible"
          [ngClass]="{ currency: col.currency, unfrozen: !col.frozen }"
          [ngStyle]="col.width && { width: col.width }"
        >
          {{ col.header | translate }}
          <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td
          *ngIf="!isReadOnly"
          pFrozenColumn
          [frozen]="freezeColumns"
          [ngClass]="{ unfrozen: !freezeColumns }"
          style="width: 36px"
        >
          <ng-container *ngIf="rowData.isPayable">
            <p-tableCheckbox
              [value]="rowData"
              style="vertical-align: text-bottom"
            ></p-tableCheckbox
          ></ng-container>
        </td>
        <td
          *ngFor="let col of columns"
          class="{{ col.field }}"
          pFrozenColumn
          [alignFrozen]="col.alignFrozen"
          [frozen]="col.frozen"
          [hidden]="!col.visible"
          [ngClass]="{
            wrap: col.wrap,
            currency: col.currency,
            unfrozen: !col.frozen
          }"
          [ngStyle]="col.width && { width: col.width }"
        >
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'payableRestrictions'">
              <span
                *ngIf="rowData.restrictionHints?.length > 0"
                style="color: rgba(0, 24, 33, 0.7)"
                ><aur-icon
                  pTooltip="{{ translateTooltip(rowData.restrictionHints) }}"
                  iconStyle="outline"
                  tooltipPosition="right"
                  color="inherit"
                  size="sm"
                  style="vertical-align: text-bottom"
                  >{{ restrictionIcon(rowData) }}</aur-icon
                ></span
              >
            </ng-container>
            <ng-container *ngSwitchCase="'invoiceNumber'">{{
              rowData.invoiceNumber
            }}</ng-container>
            <ng-container *ngSwitchCase="'confirmationNumber'">{{
              rowData.confirmationNumber
            }}</ng-container>
            <ng-container *ngSwitchCase="'transactionNumber'">{{
              rowData.transactionNumber
            }}</ng-container>
            <ng-container *ngSwitchCase="'buyerAccount'">{{
              rowData.buyerAccount
            }}</ng-container>
            <ng-container *ngSwitchCase="'poNumber'">{{
              rowData.poNumber
            }}</ng-container>
            <ng-container *ngSwitchCase="'documentDate'">
              {{
                rowData.documentDate
                  ? (rowData.documentDate
                    | paymentsEngineDatePipe: false : false
                    | async)
                  : ''
              }}
            </ng-container>
            <ng-container *ngSwitchCase="'dueDate'">
              {{
                rowData.dueDate
                  ? (rowData.dueDate
                    | paymentsEngineDatePipe: false : false
                    | async)
                  : ''
              }}
            </ng-container>
            <ng-container *ngSwitchCase="'discountDate'">
              <ng-container
                *ngIf="
                  rowData?.isPayable &&
                    (!rowData?.isCreditMemo ||
                      rowData?.appliedDiscountAmount != 0);
                  else noDiscount
                "
                >{{
                  rowData.discountDate
                    ? (rowData.discountDate
                      | paymentsEngineDatePipe: false : false
                      | async)
                    : ''
                }}</ng-container
              >
              <ng-template #noDiscount></ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="'discountAmount'">
              <span
                *ngIf="
                  rowData?.isPayable &&
                    rowData?.discountState &&
                    (!rowData?.isCreditMemo ||
                      (rowData?.isCreditMemo &&
                        rowData?.appliedDiscountAmount != 0));
                  else noDiscount
                "
                [ngStyle]="
                  !rowData?.isCreditMemo
                    ? { display: 'flex', 'justify-content': 'space-between' }
                    : {}
                "
              >
                <span
                  *ngIf="!rowData?.isCreditMemo"
                  style="color: {{ rowData.discountState.color ?? '' }};"
                  ><aur-icon
                    pTooltip="{{ rowData.discountState.hint ?? '' }} "
                    tooltipPosition="bottom"
                    color="inherit"
                    size="sm"
                    style="{{ rowData.discountState.style ?? '' }}"
                    >{{ rowData.discountState.icon ?? '' }}</aur-icon
                  ></span
                >
                <span>
                  {{
                    rowData.discountState.displayedDiscountAmount ?? 0
                      | currency
                  }}
                  <span class="text-grey"> {{ rowData.currencyCode }}</span>
                </span>
              </span>
              <ng-template #noDiscount></ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="'originalBalance'">
              {{
                (rowData.originalBalance == null ? 0 : rowData.originalBalance)
                  | currency
              }}
              <span class="text-grey"> {{ rowData.currencyCode }}</span>
            </ng-container>
            <ng-container *ngSwitchCase="'disputedAmount'">
              <ng-container
                *ngIf="
                  !!rowData?.disputeTotal && rowData?.disputeTotal != 0;
                  else noDisputedAmount
                "
                >{{ rowData.disputeTotal | currency }}</ng-container
              >
              <ng-template #noDisputedAmount></ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="'openBalance'">
              {{
                (rowData.openBalance == null ? 0 : rowData.openBalance)
                  | currency
              }}
              <span class="text-grey"> {{ rowData.currencyCode }}</span>
            </ng-container>
            <ng-container *ngSwitchCase="'amountPaid'">
              {{ rowData.amountPaid | currency }}
              <span class="text-grey"> {{ rowData.currencyCode }}</span>
            </ng-container>
            <ng-container *ngSwitchCase="'payableAmount'">
              <ng-container *ngIf="rowData.isPayable; else noPayableAmount">
                <span
                  id="payableAmount_{{
                    modifiedSessionDocuments.indexOf(rowData)
                  }}"
                  [ngClass]="{
                    touched:
                      rowData.modified === true ||
                      rowData.payOtherReasonCode === 'DocumentShortPaid'
                  }"
                >
                  {{ rowData.payableAmount | currency }}</span
                >
                <span class="text-grey">
                  {{ rowData.currencyCode }}</span
                ></ng-container
              >
              <ng-template #noPayableAmount></ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="'editPayableAmount'">
              <button
                #button
                *ngIf="rowData.isPayableAmountEditable"
                id="penIcon_{{ modifiedSessionDocuments.indexOf(rowData) }}"
                aur-button
                importance="link"
                icon="edit"
                style="border: 0"
                (click)="showDialog($event, rowData, editPaymentOverlayPanel)"
              ></button
            ></ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-overlayPanel
    #editPaymentOverlayPanel
    id="editPaymentDialog"
    [dismissable]="!isShortPaidRow"
    focusOnShow="true"
    [style]="marginStyle"
  >
    <form [formGroup]="formGroup">
      <h5 id="edit-Payment-Dialog-Header">
        {{ 'ARC_PAYMENT_EDIT_AMOUNT' | translate }}
      </h5>
      <aur-currency-input
        #editPayableAmountInput
        id="edit-pay-amount-input"
        [formGroup]="currencyInputFormControl"
        [currencyOptions]="currencyOptions"
        [decimalPlaces]="2"
        [label]="currencyInputLabel"
        class="edit-payment-dialog-currency-input"
        [autofocus]="true"
        [errorMessages]="errorMessages"
      ></aur-currency-input>
      <div *ngIf="canShowDisputeReasonDropdown()">
        <aur-field-wrapper
          class="payment-reason-field-wrapper"
          [control]="editPaymentReasonDropdownFormControl"
          label="{{ 'ARC_PAYMENT_SHORT_PAY_SELECT_REASON_LABEL' | translate }}"
        >
          <p-autoComplete
            #editPaymentReasonDropdown
            formControlName="editPaymentReasonDropdown"
            placeholder="{{ this.reasonDropdownPlaceHolderKey | translate }}"
            class="aur-dropdown"
            [maxlength]="60"
            [suggestions]="filteredDisputeReasonItems"
            (completeMethod)="filterDispute($event)"
            showEmptyMessage="false"
            field="label"
            [forceSelection]="!allowFreeFormReason"
            [dropdown]="enableAutocompleteDropdownMode"
            id="payment-reason-dropdown"
          >
            <ng-template let-dispute pTemplate="item">
              <div class="dispute-item">
                <div>{{ dispute.label }}</div>
              </div>
            </ng-template>
          </p-autoComplete>

          <aur-validation-error
            [control]="editPaymentReasonDropdownFormControl"
          ></aur-validation-error>
        </aur-field-wrapper>
      </div>
      <div class="edit-Payment-Dialog-Reason-Button-Container">
        <button
          *ngIf="!isShortPaidRow || selectedPayOtherShortPaidReason"
          aur-button
          id="edit-payable-amount-cancel-button"
          type="button"
          importance="tertiary"
          (click)="closeOverlayPanel()"
        >
          {{ 'ARC_PAYMENT_CANCEL' | translate }}
        </button>
        <button
          aur-button
          id="edit-payable-amount-save-button"
          type="submit"
          (click)="updatePayableAmount()"
        >
          {{ 'ARC_PAYMENT_SAVE' | translate }}
        </button>
      </div>
    </form>
  </p-overlayPanel>
</div>
